/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_National_IdInputs */

const cs_property_legal_national_id = /** @type {(inputs: Property_Legal_National_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RČ / IČO`)
};

const en_property_legal_national_id = /** @type {(inputs: Property_Legal_National_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`National ID / IČO`)
};

/**
* | output |
* | --- |
* | "National ID / IČO" |
*
* @param {Property_Legal_National_IdInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_national_id = /** @type {((inputs?: Property_Legal_National_IdInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_National_IdInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_national_id(inputs)
	return cs_property_legal_national_id(inputs)
});